export default __webpack_public_path__ + "static/FIX_ol-d772dd720ce2c6552e27e81d44f2d98f.pdf";